const observer: {
  handlers: WeakMap<Element, (entry: ResizeObserverEntry) => void>
  instance: ResizeObserver | null
} = {
  handlers: new WeakMap(),
  instance: new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const element = entry.target

      const observerHandler = observer.handlers.get(element)

      if (!observerHandler) {
        return
      }

      observerHandler(entry)
    })
  }),
}

export const resizeObserver = {
  observe(element: Element, callback: (entry: ResizeObserverEntry) => void) {
    observer.handlers.set(element, callback)
    observer.instance?.observe(element)
  },
  unobserve(element: Element) {
    observer.handlers.delete(element)
    observer.instance?.unobserve(element)
  },
}
